import CHECKBOX_FALSE_VALUE from "../../constants/form/CHECKBOX_FALSE_VALUE";
import CHECKBOX_TRUE_VALUE from "../../constants/form/CHECKBOX_TRUE_VALUE";

export default function toBooleanString(bool: boolean) {
  if (bool === true) {
    return CHECKBOX_TRUE_VALUE;
  }

  return CHECKBOX_FALSE_VALUE;
}
